import { axios } from 'libs';

const resource = '/userinfo';

export const reviveUserInfo = () => {
  return axios.get(resource);
};
